import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-QR-code",
  "use": "icon-QR-code-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"icon-QR-code\">\r\n<style type=\"text/css\">\r\n\t#icon-QR-code .st0{fill:#A2AAAD;}\r\n</style>\r\n<path class=\"st0\" d=\"M14,10v4h-2v-2h-2v2H6v-2h2v-2H14z M6,10v2H4v2H0v-2h2v-2H6z M4,6v2H2v2H0V8h2V6H4z M14,0v8H6V0H14z M4,0v2H2v4\r\n\tH0V0H4z M12,2H8v4h4V2z M11,3v2H9V3H11z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol